import { RefDate, RefString } from "@tblabs/truffle";
import { StepData } from "../../Step/StepData";
import { UsageStepRawData } from "./UsageStepRawData";


export class UsageStepData extends StepData
{
    public Start = new RefDate();
    public End = new RefDate();
    public StoppedBeforePlannedEnd = new RefDate();
    public CancelationReason = new RefString();

    constructor(raw: Partial<UsageStepRawData>)
    {
        super(raw);
     
        this.Start.value = new Date(raw.Start || 0);
        this.End.value = new Date(raw.End || 0);
        this.StoppedBeforePlannedEnd.value = new Date(raw.StoppedBeforePlannedEnd || 0);
        this.CancelationReason.value = raw.CancelationReason || "";
    }
}
